import { render, staticRenderFns } from "./ReceiptsData.vue?vue&type=template&id=109d0932&scoped=true&"
import script from "./ReceiptsData.vue?vue&type=script&lang=js&"
export * from "./ReceiptsData.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsData.vue?vue&type=style&index=0&id=109d0932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109d0932",
  null
  
)

export default component.exports